module.exports = (__webpack_require__(0))(64);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/AccessWidget.js from dll-reference girder_lib
// module id = 179
// module chunks = 0